import { render } from "./FormProblems.vue?vue&type=template&id=a72c3a82"
import script from "./FormProblems.vue?vue&type=script&lang=js"
export * from "./FormProblems.vue?vue&type=script&lang=js"
script.render = render

export default script